










import { setTitle } from '@/lib/dingtalk-interface'
import { isDingtalk } from '@/utils'
import { Component, Vue } from 'vue-property-decorator'
import { dingtalkAuth } from './config/auth'
import Waiting from './pages/index.vue'

@Component({
  components: {
    Waiting,
  },
})
export default class App extends Vue {
  showWaiting = false

  showPop = false

  defaultUlr = ''

  homePic = {
   common: 'https://static.h3yun.com/common-resource/operation/sample/home/home-new.png',
   produce: 'https://static.h3yun.com/common-resource/operation/sample/merp/merp.png'
  }

  async created() {
    this.$root.eventHub.$on('wait', () => {
      this.showWaiting = true
    })
    this.$root.eventHub.$on('cancel', () => {
      this.showPop = false
    })
    this.$root.eventHub.$on('success', () => {
      this.showPop = true
    })
    await this.setPicUrl()
  }

  setPicUrl() {
    if (
      window.GlobalConfig &&
      window.GlobalConfig.suiteKey === 'suitewqb0yxdr4rcebpoi'
    ) {
      // 判断是慧致造的
      this.defaultUlr = this.homePic.produce
      if (isDingtalk) {
        setTitle('慧致造')
      } else {
        document.title = '慧致造'
      }
    } else {
      this.defaultUlr = this.homePic.common
      if (isDingtalk) {
        setTitle('Hi，欢迎来到氚云')
      } else {
        document.title = 'Hi，欢迎来到氚云'
      }
    }
  }

  async auth() {
    dingtalkAuth()
  }
}
